import * as Yup from 'yup';

const phUrgencyValidation = Yup.string().required(
  'Please choose one option to continue.'
);

const phUrgencySchema = Yup.object().shape({
  ph_urgency: phUrgencyValidation
});

export { phUrgencySchema };
